export default {
    'CONSTRUCTION_DECORATION': '装修单元施工',
    'CONSTRUCTION_OPERATIONS': '营运单元施工',
    'CONSTRUCTION_SERVICE_PROVIDER': '物业服务商施工',
}
